import { render, staticRenderFns } from "./AirportPannel.vue?vue&type=template&id=655fce55&scoped=true&"
import script from "./AirportPannel.vue?vue&type=script&lang=js&"
export * from "./AirportPannel.vue?vue&type=script&lang=js&"
import style0 from "./AirportPannel.vue?vue&type=style&index=0&id=655fce55&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655fce55",
  null
  
)

export default component.exports